import { FormattedMessage } from 'react-intl';

import { Box, Link, Typography } from '@mui/material';

import { STRData } from '@arrived/common';

const ChartComponent = ({ chartImgSrc, chartName }: { chartImgSrc: string; chartName: string }) => (
  <Box width="100%" mt={3} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
    <Typography variant="h6.bold">
      <FormattedMessage id="property-details-chart-airdna-title" defaultMessage={chartName} />
    </Typography>
    <img src={chartImgSrc} alt={`AirDNA historical ${chartName} data`} width="100%" style={{ maxWidth: '800px' }} />
    <Typography variant="caption">
      <FormattedMessage
        id="property-details-airdna-note"
        defaultMessage="Data provided by {airdnaLink}"
        values={{
          airdnaLink: (
            <Link variant="inherit" href="https://www.airdna.co" target="_blank">
              AirDNA
            </Link>
          ),
        }}
      />
    </Typography>
  </Box>
);

export const STRHistoricalInfoSection = ({
  historicalData,
}: {
  historicalData: NonNullable<STRData['historicalData']>;
}) => (
  <>
    <Typography variant="h4.semibold">
      <FormattedMessage id="property-details-historical-rental-data" defaultMessage="Rental Data" />
    </Typography>
    <Typography variant="body1" mt={1.5}>
      <FormattedMessage
        id="str-rental-data-catpion"
        defaultMessage="The below data is from AirDNA and shows performance for similar sized homes in the 75th percentile for this market"
      />
    </Typography>
    <ChartComponent chartName="Avg Daily Rate" chartImgSrc={historicalData.dailyRateChartImageSrc} />
    <ChartComponent chartName="Monthly Revenue" chartImgSrc={historicalData.monthlyRevenueChartImageSrc} />
    <ChartComponent chartName="Monthly Occupancy" chartImgSrc={historicalData.occupancyChartImageSrc} />
  </>
);
